import { useAchievementTypes, useReduxState } from 'hooks';
import { CategoryBadges } from 'components/common';
import { AchievementIcon } from '.';

import type { AchievementExtended } from 'shared-types';

interface Props {
  achievement: Pick<AchievementExtended, 'categories' | 'title' | 'type'>;
  children: React.ReactNode;
}

const AchievementsTileContent = ({ achievement, children }: Props) => {
  const { theme } = useReduxState();

  const achievementTypes = useAchievementTypes();

  return (
    <div className="wrapper">
      <div className="icon-container">
        <AchievementIcon type={achievement.type} />
      </div>

      <div className="content">
        <div className="type">{achievementTypes[achievement.type].title}</div>
        <div className="title">{achievement.title}</div>

        <CategoryBadges categories={achievement.categories} />

        {children}
      </div>

      <style jsx>{`
        .wrapper {
          display: flex;
          flex-direction: column;
          gap: 15px;
          height: 100%;
          min-height: 200px;
        }
        .icon-container {
          align-items: center;
          display: flex;
          gap: 10px;
          justify-content: flex-start;
        }
        .content {
          display: flex;
          flex-grow: 1;
          flex-direction: column;
        }
        .type {
          color: ${theme.textColorLight};
          font-size: 1.4rem;
          font-weight: 600;
        }
        .title {
          font-size: 1.6rem;
          font-weight: 700;
          display: -webkit-box;
          margin-top: 3px;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
      `}</style>
    </div>
  );
};

export default AchievementsTileContent;
